import { createFileRoute } from "@tanstack/react-router";
import { ChecklistTool } from "@/features/marketing/tools/checklist-tool";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/$lang/wedding-checklist")({
  head: SEO.checklist,
  component: ChecklistTool,
});
